<template>
  <div class="agree-list-wrapper">
    <section
      class="agree-wrapper"
      v-for="(item, index) in agreeList"
      :key="index"
    >
      <div class="agree-text">
        <i
          @click="handleClick('agree', item, index)"
          :class="[
            {
              active: item.value,
            },
          ]"
        ></i>
        <span @click="handleClick('agree', item, index)">{{
          $t("home.agree0")
        }}</span>
        <span @click="handleClick('rule', item, index)" class="active">{{
          item.title || $t("home.agree1")
        }}</span>
      </div>
    </section>
  </div>
</template>
<script>
import { emitFormUpdate } from "../../tools/utils";
export default {
  props: ["formItem", "idx"],
  data() {
    return {
      agreeList: [],
    };
  },
  mounted() {},
  computed: {
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
  },
  watch: {
    formItem: {
      handler(newV) {
        this.agreeList = newV.options;
        console.log(this.agreeList)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleClick(type, config, index) {
      switch (type) {
        case "agree":
          // config.is_agree =
          //   config.is_agree === null
          //     ? !config.default_select
          //     : !config.is_agree;
          this.formItem.options[index].value = !config.value
          emitFormUpdate(this, this.idx)
          if (config.is_agree) {
            try {
              Omega.trackEvent("tone_p_x_login_law_ck");
            } catch (e) {}
          }
          break;
        case "rule":
          Omega.trackEvent("ibt_gd_whatsapp_terms_link_ck");

          let lang = this.params.get("lang");
          let url =
            config.link ||
            `https://common.didiglobal.com/common/v6/driver/law?location_country=${this.location_country}&lang=${lang}`;
          window.location.href = url;
          break;
        default:
          break;
      }
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.agree-list-wrapper {
  padding: 0 0.4rem;
  margin: 0.32rem 0 0.56rem 0;
  .agree-wrapper {
    display: flex;
    margin-bottom: 0.08rem;
    .agree-text {
      > i {
        display: inline-block;
        position: relative;
        top: 1px;
        margin-right: 0.1rem;
        vertical-align: middle;
        width: 0.38rem;
        height: 0.38rem;
        background-size: 0.36rem;
        @include bg-img("icon-unchecked", "../../images/");
        &.active {
          @include bg-img("icon-checked", "../../images/");
        }
      }
      > span {
        // display: inline-block;
        vertical-align: middle;
        color: #999;
        font-size: 0.28rem;
        &.active {
          color: $main-orange;
        }
      }
    }
  }
}
</style>


